// en, de, fr, pt
export default {
    en: {
        /* Global */
        Datas: "Datas",
        Links: "Links",
        Confirm:"Confirm",
        Introduction:"Introduction",
        Image:"Image",
        /* Labels */
        All:"All",
        Hotposts:"Hotposts",
        Overlays:"Overlays",
        "Video Overlays":"Video Overlays",
        XRays:"XRays",
        Directionals:"Directionals",
        Pins:"Pins",
        /* forms */
        title:"Title",
        base_image : "Image",
        order: "Order",
        /* Links */
        "No linked" : "No linked",
        /* Functions */
        Functions : "Functions",
        "Copy to another" : "Copy to another",
        /* Interactive Images */
        "Interactive Image" : "Interactive Image",
        Chapter:"Chapter",
        "Chapter datas":"Chapter datas",
        Chapters:"Chapters",
        intro_title: "Title",
        intro_subtitle: "Subtitle",
        intro_text: "Text",
        intro_image: "Image",
        width: "Width",
        height: "Height",
        bounding_box: "Pan Zoom",
        bounding_box_pan_horizontal: "Pan Horizontal",
        bounding_box_pan_vertical: "Pan Vertical",
        display_chapters_titles: "Display chapter title",
    },
    fr: {}
}
